var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiderLastLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.71573 0 0 6.71573 0 15C0 22.2959 5.20885 28.3752 12.1106 29.722C12.4054 29.7795 12.6655 29.9564 12.8156 30.2166L14.134 32.5C14.5189 33.1667 15.4811 33.1667 15.866 32.5L17.1844 30.2166C17.3345 29.9564 17.5946 29.7795 17.8894 29.722C24.7912 28.3752 30 22.2959 30 15C30 6.71573 23.2843 0 15 0Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29Z",
    stroke: "#252525",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 13.3952C16.7137 13.3952 18.1032 11.9636 18.1032 10.1976C18.1032 8.43162 16.7137 7 14.9998 7C13.2859 7 11.8965 8.43162 11.8965 10.1976C11.8965 11.9636 13.2859 13.3952 14.9998 13.3952Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6663 20.0665C12.678 20.0545 12.6897 20.0425 12.6897 20.0305L18.173 14.6691C17.3447 13.8757 16.2247 13.3828 14.9997 13.3828C12.4213 13.3828 10.333 15.5346 10.333 18.1913V20.0665H12.6663Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6662 20.0669V18.1916C19.6662 17.1457 19.3395 16.184 18.7912 15.3906L14.0078 20.0669H19.6662Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 21.0283V21.7977C10.333 22.4588 10.858 22.9998 11.4997 22.9998H18.488C19.1297 22.9998 19.6547 22.4588 19.6547 21.7977V21.0283H10.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiderLastLocation);
export default __webpack_public_path__ + "static/media/rider-last-location.35ba95d8d0c5cb890cc78c14d6e2cdcd.svg";
export { ForwardRef as ReactComponent };